import { render, staticRenderFns } from "./DynamicBySourceBody.vue?vue&type=template&id=39ff9a2c&"
import script from "./DynamicBySourceBody.vue?vue&type=script&lang=js&"
export * from "./DynamicBySourceBody.vue?vue&type=script&lang=js&"
import style0 from "./DynamicBySourceBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports